import * as angular from "angular";
import {IController} from "angular";

export class emptyStateCtrl implements IController {

  src: any;
  text: string;
  description?: string;
  action: any;
  onAction: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }

}

angular
  .module('bringoz.admin.commons')
  .component( 'emptyState', {
    bindings: {
      src: '@',
      text: '@',
      description: '@?',
      action: '<',
      onAction: '&?'
    },
    template: require('./empty-state.html').default,
    controller: emptyStateCtrl
  });

